import { Actions } from "./Actiontypes";

export const setRecords = (records) => ({
  type: Actions.SET_RECORDS,
  payload: records,
});

export const resetTeamPlan = () => ({
  type: Actions.RESET_TEAM_PLAN,
});
